// NavSearchButtonMobile.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useNavHeader from '../hook/useNavHeader.js';
import { useTranslation } from 'react-i18next';
import Tooltip from '../component/Tooltip.jsx';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import getNavigationIcon, {
  NavigationId,
} from '../resource/getNavigationIcon.js';
import { Icon, IconSection, TooltipStyle } from '../style/NavHeader.js';

export const NavSearchButtonMobile = ({ isSearchModalOpened = false }) => {
  const { dataElementId, onClickSearch } = useNavHeader();
  const { t } = useTranslation();

  return (
    <IconSection>
      <Tooltip
        position="bottom-center"
        renderHint={() => (
          <TooltipStyle>
            {t('tabbar_search', {
              ns: TranslationNamespace.GENERAL,
            })}
          </TooltipStyle>
        )}
        trigger="hover"
      >
        <SearchIcon
          data-element_id={dataElementId}
          onClick={onClickSearch}
          isMatch={isSearchModalOpened}
          aria-label={t('tabbar_search', {
            ns: TranslationNamespace.GENERAL,
          })}
        >
          <img
            src={getNavigationIcon({
              navigationId: NavigationId.SEARCH,
              isMatch: isSearchModalOpened,
            })}
            alt={t('tabbar_search', {
              ns: TranslationNamespace.GENERAL,
            })}
          />
        </SearchIcon>
      </Tooltip>
    </IconSection>
  );
};

NavSearchButtonMobile.propTypes = {
  isSearchModalOpened: PropTypes.bool,
};

const SearchIcon = styled(Icon)``;

export default NavSearchButtonMobile;
